var RouteService = /** @class */ (function () {
    function RouteService(router) {
        this._router = router;
    }
    Object.defineProperty(RouteService.prototype, "menuRoutes", {
        get: function () {
            var allRoutes = this.allRoutes;
            var mainNavRoutes = [];
            allRoutes.forEach(function (value) {
                if (value.meta && value.meta.mainNav)
                    mainNavRoutes.push(value);
            });
            return mainNavRoutes;
        },
        enumerable: false,
        configurable: true
    });
    RouteService.prototype.goToRecordHistory = function () {
        var recordHistoryRoute = this.matchingRouteConfigByPath("/recordHistory");
        this.pushRoute(recordHistoryRoute);
    };
    RouteService.prototype.goToFrontPage = function () {
        var recordHistoryRoute = this.matchingRouteConfigByName("frontPage");
        this.pushRoute(recordHistoryRoute);
    };
    RouteService.prototype.goToCorrespondenceFrontPage = function () {
        var recordHistoryRoute = this.matchingRouteConfigByName("correspondences");
        this.pushRoute(recordHistoryRoute);
    };
    Object.defineProperty(RouteService.prototype, "yearlyReportRoutes", {
        get: function () {
            return this.recordRoutes("/organisationYearlyReport/");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RouteService.prototype, "aidApplicationRoutes", {
        get: function () {
            return this.recordRoutes("/aidApplication/");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RouteService.prototype, "expandedSBERoutes", {
        get: function () {
            return this.recordRoutes("/expandedsbe/");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RouteService.prototype, "summaryReportRoutes", {
        get: function () {
            return this.recordRoutes("/summaryReport/");
        },
        enumerable: false,
        configurable: true
    });
    RouteService.prototype.recordRoutes = function (path) {
        var routeConfig = this.matchingRouteConfigByPath(path);
        return routeConfig.children;
    };
    RouteService.prototype.matchingRouteConfigByPath = function (startsWith) {
        return this.allRoutes.find(function (route) { return route.path.startsWith(startsWith); });
    };
    RouteService.prototype.matchingRouteConfigByName = function (name) {
        return this.allRoutes.find(function (route) { return route.name == name; });
    };
    Object.defineProperty(RouteService.prototype, "allRoutes", {
        get: function () {
            return this._router.options.routes;
        },
        enumerable: false,
        configurable: true
    });
    RouteService.prototype.isFirstIndex = function () {
        return this.getRouteIndex() == 0;
    };
    RouteService.prototype.isLastIndex = function () {
        var siblings = this.getSiblingRoutes();
        return this.getRouteIndex() == siblings.length - 1;
    };
    /**
     *
     * Gets the current route index in the list of sibling routes
     *
     * */
    RouteService.prototype.getRouteIndex = function () {
        var siblings = this.getSiblingRoutes();
        return this.getCurrentIndex(siblings);
    };
    /**
     *
     * Returns the route section number or index + 1 of the current route.
     *
     * */
    RouteService.prototype.routeSectionNumber = function () {
        var meta = this._router.currentRoute.meta;
        var hasSectionNumber = !!meta && !!meta.section;
        return hasSectionNumber
            ? meta.section
            : this.getRouteIndex() + 1;
    };
    RouteService.prototype.goToNext = function (routeArr) {
        if (routeArr === void 0) { routeArr = null; }
        var routes = routeArr ? routeArr : this.getSiblingRoutes();
        var currentIndex = this.getCurrentIndex(routes);
        // Limit max index to maximum index in the siblings list
        var nextIndex = Math.min(routes.length - 1, currentIndex + 1);
        var next = routes[nextIndex];
        this.pushRoute(next);
    };
    RouteService.prototype.goToPrevious = function (routeArr) {
        if (routeArr === void 0) { routeArr = null; }
        var routes = routeArr ? routeArr : this.getSiblingRoutes();
        var currentIndex = this.getCurrentIndex(routes);
        // Limit min index to 0
        var previousIndex = Math.max(0, currentIndex - 1);
        var previous = routes[previousIndex];
        this.pushRoute(previous);
    };
    RouteService.prototype.pushRoute = function (route) {
        route = this.cleanMergedParameters(route);
        this._router.push(route);
    };
    RouteService.prototype.cleanMergedParameters = function (route) {
        // TODO: Find a way to fix this properly (updating VueRoute may or may not work).
        // (ref: https://github.com/vuejs/vue-router/issues/2800)
        //
        // Vue Router does a thing called parameter merging which essentially means that 
        //  eg. the operaoncetion subroute has been resolved for id 'abc' then vue router
        // will store the 'params' collection which was used with the subroute.
        // If the user now switches to another aid application with id '123' and navigates
        // to the operation subroute then vue router will merge the previous 'params' 
        // collection with the present collection. Doing this will override the id '123' 
        // with value 'abc' which will cause vue to route to aidapplication/abc/operation 
        // instead of aidapplication/123/operation. 
        //
        // The reason why our application works regardless of this 'feature' is that we use a 
        // Vuex persisted recordId for all server reads and writes. This recordId gets set 
        // when the enclosing view is loaded, hence, we end up with a situation in which 
        // VueRouter routes us to a wrong URL but all server reads and writes work as 'expected'
        //
        // This bit of hack code seems to fix this issue by 'resetting' the 
        // persisted id property of the merged params collection. 
        var props = Object.getOwnPropertyNames(route);
        if (props.includes("params"))
            delete route.params.id;
        return route;
    };
    /**
     *
     * Gets all the sibling routes of the current route
     * NOTE! Supports only two level route hierarchies. Ie. parent routes are in the root and their children on the next level.
     *
     * */
    RouteService.prototype.getSiblingRoutes = function () {
        var matches = this._router.currentRoute.matched;
        // No matches - this should not happen
        if (!matches)
            throw new Error();
        // Current route match is always the last item on the 'matches' list
        var parentRoute = matches[matches.length - 1].parent;
        if (parentRoute) {
            var parentConfig = this.allRoutes.find(function (route) { return route.path === parentRoute.path; });
            return parentConfig.children;
        }
        else {
            return this.allRoutes;
        }
    };
    /**
     *
     * Gets the index of the current route
     * NOTE! Supports only two level route hierarchies. Ie. parent routes are in the root and their children on the next level.
     *
     * */
    RouteService.prototype.getCurrentIndex = function (siblings) {
        var _this = this;
        var currentIndex = siblings.findIndex(function (route) {
            return route.name
                ? route.name === _this._router.currentRoute.name
                : route.path === _this._router.currentRoute.path;
        });
        return currentIndex;
    };
    return RouteService;
}());
export default RouteService;
